import {
  getBasePrice,
  getWeddingsServedRange,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { memo } from 'react';
import ProfileHighlightsComponent from '@bridebook/web/app-basic/components/supplier/sections/profile-highlights/profile-highlights';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';

const ProfileHighlights = () => {
  const market = useMarket();
  const weddingsServedRange = useSelector(getWeddingsServedRange);
  const priceFrom = useSelector(getBasePrice);

  return weddingsServedRange && priceFrom ? (
    <ProfileHighlightsComponent
      priceFrom={priceFrom}
      weddingsServedRange={weddingsServedRange}
      currency={market.currency}
      market={market}
    />
  ) : null;
};

export default memo(ProfileHighlights);
